import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';

import OrDivider from 'components/OrDivider';
import { validateMerchant } from 'actions/applePay';

import styles from './styles.module.scss';

const ApplePayButton = ({ className, showDivider, getAmountToPay, disabled, processPayment, validatePayment }) => {
  const dispatch = useDispatch();

  const onValidateMerchant = async (event, session) => {
    dispatch(validateMerchant({
      data: { validationUrl: event.validationURL },
      success: (res) => {
        session.completeMerchantValidation(res);
      },
      fail: (err) => {
        console.log('Validation error:', err);
        session.abort();
      },
    }));
  };

  const onPaymentAuthorized = async (event, session) => {
    console.log('Payment authorization started');

    const successCallback = (res) => {
      session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
      console.log('Payment successful:', res);
    };

    const failCallback = (err) => {
      console.log('Payment error:', err);
      session.completePayment(window.ApplePaySession.STATUS_FAILURE);
    };

    processPayment(event.payment, successCallback, failCallback);
  };

  const onCancel = () => {
    console.log('Payment cancelled');
  };

  const handleApplePayButtonClick = (event) => {
    event.preventDefault();
    console.log('Apple Pay button clicked');

    if (validatePayment()) {
      try {
        // Basic payment request with minimum required fields
        const paymentRequest = {
          countryCode: 'US',
          currencyCode: 'USD',
          total: {
            label: 'LendingUSA',
            amount: getAmountToPay().toFixed(2),
          },
          supportedNetworks: ['visa', 'masterCard'],
          merchantCapabilities: ['supports3DS', 'supportsDebit'],
          requiredBillingContactFields: ['name', 'postalAddress'],
        };

        console.log('Creating payment request:', JSON.stringify(paymentRequest));

        // Create the session
        const session = new window.ApplePaySession(3, paymentRequest);

        // Setup handlers
        session.onvalidatemerchant = (evt) => onValidateMerchant(evt, session);
        session.onpaymentauthorized = (evt) => onPaymentAuthorized(evt, session);
        session.oncancel = () => onCancel();

        // Begin the session
        console.log('Beginning Apple Pay session');
        session.begin();
      } catch (error) {
        console.log(`Error: ${error.message}`);
      }
    }
  };

  return (
    <>
      {showDivider && <OrDivider />}
      <button
        className={cn('btn', 'btn-primary', styles['apple-pay-button'], className)}
        type="button"
        aria-label="Apple Pay Button"
        disabled={disabled}
        onClick={handleApplePayButtonClick}
      />
    </>
  );
};

ApplePayButton.propTypes = {
  className: PropTypes.string,
  showDivider: PropTypes.bool,
  getAmountToPay: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  validatePayment: PropTypes.func.isRequired,
  processPayment: PropTypes.func.isRequired,
};

ApplePayButton.defaultProps = {
  className: '',
  showDivider: true,
  disabled: false,
};

export default ApplePayButton;
